const isValidCallbackAudio = ({ block }: any) => {
    const {
        data: { audio },
    } = block;

    return {
        isValid: Boolean(audio.trim()),
        error: (
            // <Alert
            //     message="Validation Error"
            //     description={`Video Block cannot be empty`}
            //     type="error"
            //     showIcon
            // />
            <></>
        ),
    };
};

export default isValidCallbackAudio;
